import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React, { useRef } from 'react'
import SvgSearch from 'src/components/Svgs/SvgSearch'
import Trns from 'src/localization/Trns'
import { css } from 'styled-components'

interface KeywordFilterProps {
  className?: string
  value: string
  onChange: (v: string) => void
  onClick?: () => void
  showLabel?: boolean
  placeholder: string
  forceFocus?: boolean
}

const KeywordFilter: React.FC<KeywordFilterProps> = (
  props,
): React.ReactElement => {
  const inputRef = useRef<HTMLInputElement | null>(null)

  if (props.forceFocus && inputRef.current !== null) {
    inputRef.current.focus()
  }

  return (
    <div
      className={props.className}
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      {props.showLabel && (
        <span
          css={css`
            margin-bottom: 10px;
            ${getFontCss(
              14,
              styleConstants.colors.gray_darkest,
              styleConstants.fontFamilies.regular,
            )};
          `}
        >
          <Trns source={'Filter by Keyword'} />
        </span>
      )}
      <div
        css={css`
          display: flex;
          align-items: center;
          height: 40px;
          padding: 0px 15px;
          background-color: ${styleConstants.colors.gray_lightest};
          border: 1px solid ${styleConstants.colors.gray_medium};
          border-radius: 6px;

          &:focus-within,
          &:hover {
            background-color: ${styleConstants.colors.white};
            border: 1px solid ${themeConstants.colors.cta};
          }
        `}
      >
        <SvgSearch
          css={css`
            margin-right: 5px;
          `}
        />
        <input
          data-testid={'keywordFilterInput'}
          ref={inputRef}
          css={css`
            height: 100%;
            flex-grow: 2;
            border: none;
            background-color: transparent;
            ${getFontCss(
              14,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.regular,
            )};

            &::placeholder {
              ${getFontCss(
                14,
                styleConstants.colors.gray_darkest,
                styleConstants.fontFamilies.regular,
              )};
              opacity: 0.5;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          `}
          placeholder={props.placeholder}
          type={'text'}
          value={props.value}
          onClick={props.onClick}
          onChange={(e): void => {
            props.onChange(e.target.value)
          }}
        />
      </div>
    </div>
  )
}

export default KeywordFilter
